const formatNumericValue = (val) => {
  const units = [
    { value: 1e12, symbol: "T" },
    { value: 1e9, symbol: "B" },
    { value: 1e6, symbol: "M" },
    { value: 1e3, symbol: "K" },
  ];

  for (const unit of units) {
    if (val >= unit.value) {
      const divided = val / unit.value;
      const formatted = Number(divided.toFixed(10)).toString();
      return `${formatted}${unit.symbol}`;
    }
  }

  return val.toString();
};

export const FormatePrice = (amount) => {
  if (amount == null || amount === "") return "";

  // If already formatted (contains K, M, B, T)
  if (typeof amount === "string" && /[KMBTkmbt]/.test(amount)) {
    return amount; // return as it is
  }

  const num = Number(String(amount).replace(/,/g, ""));

  if (isNaN(num)) {
    return amount; // return original if not valid number
  }

  return formatNumericValue(num);
};

export default FormatePrice;